import { useState } from 'react';
import { Users, UserPlus, Trash2, MailWarning } from 'lucide-react';
import { Button } from '../ui/button';
import { Carte, TitreCarte, nomComplet, qualiteOrg } from './constantes';
import { AjoutAnnuaireDialog } from './AjoutAnnuaireDialog';
import { AjoutExterneDialog } from './AjoutExterneDialog';

const initiales = (p) => `${(p.prenom || '')[0] || ''}${(p.nom || '')[0] || ''}`.toUpperCase();

const LigneParticipant = ({ p, onRetirer }) => (
  <li className="flex items-center gap-3 py-3" data-testid={`cp-participant-${p.participant_id}`}>
    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-bold text-slate-600">{initiales(p)}</span>
    <div className="min-w-0 flex-1">
      <p className="truncate text-sm font-semibold text-[#0F172A]">{nomComplet(p)}
        {!p.user_id && <span className="ml-2 rounded-full bg-sky-50 px-2 py-0.5 text-[10px] font-semibold text-sky-700">Extérieur</span>}
      </p>
      <p className="truncate text-xs text-slate-500">{qualiteOrg(p)}</p>
    </div>
    <span className="hidden max-w-[240px] truncate text-xs text-slate-500 md:block">
      {p.email || <span className="inline-flex items-center gap-1 text-amber-600"><MailWarning className="h-3.5 w-3.5" /> Pas d'e-mail</span>}
    </span>
    <button type="button" onClick={onRetirer} title="Retirer" data-testid={`cp-participant-retirer-${p.participant_id}`}
      className="rounded-lg p-2 text-slate-400 transition-colors hover:bg-red-50 hover:text-red-600"><Trash2 className="h-4 w-4" /></button>
  </li>
);

export const OngletParticipants = ({ cp }) => {
  const { conseil, enregistrer } = cp;
  const [annuaire, setAnnuaire] = useState(false);
  const [externe, setExterne] = useState(false);
  const parts = conseil.participants;
  const maj = (liste, msg) => enregistrer({ participants: liste }, msg);
  const retirer = (p) => {
    if (window.confirm(`Retirer ${nomComplet(p)} du conseil ? Sa présence et sa signature à l'écran seront perdues.`)) {
      maj(parts.filter((x) => x.participant_id !== p.participant_id), 'Participant retiré');
    }
  };
  return (
    <Carte data-testid="cp-participants">
      <TitreCarte Icone={Users} titre={`Participants (${parts.length})`}
        sousTitre="Formateurs, maîtres d'apprentissage, entreprises, apprentis délégués, direction… et personnes extérieures (OPCO, partenaires).">
        <Button variant="outline" onClick={() => setExterne(true)} data-testid="cp-ajouter-externe"><UserPlus className="mr-2 h-4 w-4" /> Personne extérieure</Button>
        <Button onClick={() => setAnnuaire(true)} className="bg-[#0F172A]" data-testid="cp-ajouter-annuaire"><Users className="mr-2 h-4 w-4" /> Ajouter depuis l'appli</Button>
      </TitreCarte>
      {parts.length === 0 && <p className="rounded-xl border border-dashed border-slate-200 p-8 text-center text-sm text-slate-400" data-testid="cp-participants-vide">Aucun participant pour l'instant</p>}
      <ul className="divide-y">
        {parts.map((p) => <LigneParticipant key={p.participant_id} p={p} onRetirer={() => retirer(p)} />)}
      </ul>
      <AjoutAnnuaireDialog open={annuaire} onClose={() => setAnnuaire(false)} dejaIds={parts.map((p) => p.user_id).filter(Boolean)}
        onAjouter={(sel) => maj([...parts, ...sel.map((p) => ({ ...p, presence: '' }))], `${sel.length} participant(s) ajouté(s)`)} />
      <AjoutExterneDialog open={externe} onClose={() => setExterne(false)} onAjouter={(p) => maj([...parts, p], 'Participant ajouté')} />
    </Carte>
  );
};
